import { routes } from "@routes/routes.ts";

import type { IExtendedRouteObject } from "@routes/types.ts";

export const layoutRoutes: IExtendedRouteObject[] = routes;
